/* eslint no-useless-concat: 0 */
/* eslint no-useless-concat: 0 */
/* eslint no-unused-vars: 0 */

import React, { Component } from "react";
import { useLocation,useNavigate } from 'react-router-dom'
import PageTitle from "../../Theme/PageTitle/index.js";
import DashboardLayout from "../../Theme/DashboardLayout/index.js";
import { Modal } from "antd";
import GanttChartTimeline, {
  TimelineHeaders,
  SidebarHeader,
  TimelineMarkers,
} from 'react-calendar-timeline' // new
import containerResizeDetector from 'react-calendar-timeline';
import './ScheduleView.scss'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
import isSameOrAfter from "dayjs/plugin/isSameOrAfter.js";
import advancedFormat from 'dayjs/plugin/advancedFormat.js';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(advancedFormat);
import groupRendererPosted from '../utils/groupRendererPosted.js';
import generateGroups from './utils/generate-timeline/generateGroups.js';
import generateItems from './utils/generate-timeline/generateItems.js';
import Spinner from '../../Theme/Spinner/index.js';
import CustomPrimaryDateHeader from './CustomPrimaryDateHeader.js';
import CustomDateHeader from './CustomDateHeader.js';
import CustomHourlyHeader from './CustomHourlyHeader.js';
import DayMarkers from './DayMarkers.js';
import ItemModalDetails from './ItemModalDetails.js';

import { bindActionCreators } from "redux";
import * as postedScheduleActions from '../../../redux/actions/postedScheduleActions.js';  // TODO: remove dispatch / action from this component
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getOffsetTime from '../../../utils/getOffsetTime.js';

import lodash from 'lodash';
const { cloneDeep } = lodash;

/**
 * Displays the one to two day schedule. When the component is first called it uses redux to call the api to get the
 * data from the database. It then calls generateItems and generateResources to correctly format the data it recieves from the api.
 * After the data has beeen formatted correctly it displays the information.
 */
class PostedScheduleView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widescreen: false,
      resource: '',
      postedSchedule: '',
      resources: '',
      tours: '',
      startDate: '',
      scheduleFormat: '',
      itemModal: false,
      itemDetails: '',
      tourModalDisplay: '',
      backRedirect: ''
    };
    
  }


  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.readyApiCall();
    this.customBrowserBackNavigation()
  }

  customBrowserBackNavigation = () => {
    // event handler for browser back button
    // Note: only works when AppRouter component wraps Switch w/ HashRouter
    window.onpopstate = () => {
      const { pathname } = this.props.navigate.location;
      if (pathname === '/posted-schedule-view-short') {
        this.setState({
          backRedirect: '/posted-schedules'
        });
      }
    }
  }

  readyApiCall = async () => {
    let resource = {
      id: this.props.resource.id || this.props.user.login.resourceId,
      name: this.props.resource.name || this.props.user.userDemographics.name
    }

    if (this.props.location.state) {  // redirected from PostedSchedulesPage with props
      const { startDate, scheduleFormat, postedId } = this.props.location.state;
      
      await this.props.actions.updatedPostedScheduleParameters({
        startDate,
        scheduleFormat,
        postedId,
        resourceId: resource.id,
        resourceName: resource.name
      })

      this.getDataFromApi(resource, startDate, scheduleFormat, postedId);

    } else { // on page refresh, pull postedSchedule from local storage
      let params = cloneDeep(this.props.postedScheduleParameters);

      const { startDate, scheduleFormat, postedId } = params;
      this.getDataFromApi(resource, startDate, scheduleFormat, postedId);
    }
  }

  getDataFromApi = async (resource, startDate, scheduleFormat, postedId) => {
    if (startDate.length>0){
      let tempDate = dayjs(startDate).format("MM/D/YYYY");
      startDate = tempDate;
    }
    await this.props.actions.fetchPostedSchedules(startDate, scheduleFormat, postedId, resource.id, resource.name).catch(error => {
      alert("Loading posted schedules failed" + JSON.stringify(error));
    });
    this.setState({
      postedSchedule: await this.props.postedSchedule,
    }, async () => {
      if (this.state.postedSchedule.resourceCollectionId) {
        // console.log(this.state.postedSchedule.resourceCollectionId);
        await this.props.actions.fetchResourceCollectionInformation({ resourceCollectionId: this.state.postedSchedule.resourceCollectionId }).catch(error => {
          console.log(error)
        });
      }

      this.setState({
        startDate: this.state.postedSchedule.startDate,
        scheduleFormat,
        tours: generateItems(this.state.postedSchedule.postedSchedule,null,this.state.postedSchedule.startDate),
        resources: generateGroups(this.state.postedSchedule.postedSchedule),
        resourceCollectionName: this.props.resourceCollectionInfo.name || ''
      });
    });
  }

  resize = () => {
    if (window.innerWidth >= 600) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  handleItemClick = async (item) => {
    const idx = await this.state.postedSchedule.postedSchedule.findIndex((elem) => {
      return elem.rId === item.group;
    });
    const resource = this.state.postedSchedule.postedSchedule[idx];
    this.setState({
      itemModal: true
    });
    let itemDetails;
    if (item.itemType === 'assignment') {
      const startTime = dayjs(item.start_time).format('h:mm a, MMM Do');
      const endTime = dayjs(item.end_time).format('h:mm a, MMM Do');
      const startTimeReal = item.start_time_real
        ? dayjs(item.start_time_real).format('h:mm a, MMM Do')
        : null;
      let assignment;
      if (item.backgroundColor === "#ffcc66") { // if assignment has a gold background color it must be on-call / stand by
        assignment = resource.dayTypes[item.rdtId] && resource.dayTypes[item.rdtId].tour && resource.dayTypes[item.rdtId].tour.assignments[item.id] ? resource.dayTypes[item.rdtId].tour.assignments[item.id] : resource.dayTypes[item.rdtId].assignment;
      } else assignment = resource.dayTypes[item.rdtId].tour.assignments[item.id];
      const { service, costObject, costObjectNumber,
        comment, description, requestNumber, myAssignmentComment, assignmentContract,overtimeReason } = assignment;
      itemDetails = {
        itemType: item.itemType,
        title: 'Assignment Details',
        description,
        comment,
        startTime,
        ...(startTimeReal ? { startTimeReal } : {}),
        endTime,
        service,
        costObject,
        costObjectNumber,
        requestNumber,
        myAssignmentComment,
        assignmentContract,
        overtimeReason
      };
    } else if (item.itemType === 'off-request') {
      // For day off requests that go over multiple days
      let tempId;
      if (typeof (item.id) === 'string' && item.id.includes('-') && item.itemType === 'off-request') {
        tempId = item.id.split('-')[0];
      } else tempId = item.id;
      const date = dayjs(item.start_time).format('M/D/YYYY');
      const { dayTypeName } = resource.dayTypes[item.id];
      const { dayOffRequestTitle, dayTypeComment, myDayTypeComment } = resource.dayTypes[item.id].dayOffRequest;
      itemDetails = {
        itemType: item.itemType,
        title: 'Day Type Request Details',
        dayOffRequestTitle,
        dayTypeName,
        dayType: "Day Off Request",
        date,
        dayTypeComment,
        myDayTypeComment
      };
    } else if (item.itemType === 'off-time') {
      const date = dayjs(item.start_time).format('M/D/YYYY');
      const { dayTypeName } = resource.dayTypes[item.id];
      const { abbreviation, dayTypeComment, myDayTypeComment, showCostObjectId,costCenter,wbse } = resource.dayTypes[item.id].dayOff;
      itemDetails = {
        itemType: item.itemType,
        title: 'Day Type Details',
        abbreviation,
        dayTypeName,
        date,
        dayTypeComment,
        myDayTypeComment,
        showCostObjectId,
        costCenter,
        wbse
      };
    } else if (
      item.itemType === 'tour'
      || item.itemType === 'overtime'
      || item.itemType === 'meal'
    ) {
      const { startTime, duration, remainDuration, meal, notificationComment, tourComment, myTourComment, tourContract, costCenter, wbse } = resource.dayTypes[item.rdtId].tour;
      const initialTourTime = dayjs.unix(startTime);
      const timeOffset = dayjs().utcOffset()*-1;
      const momentStartTime = dayjs(initialTourTime).add(timeOffset, 'minute');
      const dayTypeTitle = resource.dayTypes[item.rdtId].title;
      const tourStartTime = momentStartTime.format('h:mm a, MMM Do');
      const actualDuration = momentStartTime.format('h:mma') === '12:00am' && remainDuration
        ? duration - remainDuration : duration;
      const tourEndTime = dayjs(tourStartTime, 'h:mm a, MMM Do').add(+actualDuration, 'hour').format('h:mm a, MMM Do');
      const mealStartTime = resource.dayTypes[item.rdtId].tour.meal ? dayjs.unix(meal.mealTime).add(timeOffset, 'minute').format('h:mm a,  MMM Do') : 'N/A';
      const mealEndTime = resource.dayTypes[item.rdtId].tour.meal ? dayjs.unix(meal.mealEndTime).add(timeOffset, 'minute').format('h:mm a, MMM Do') : 'N/A';
      itemDetails = {
        itemType: item.itemType,
        title: 'Tour Details',
        dayTypeTitle: dayTypeTitle ? dayTypeTitle : "N/A",
        tourStartTime,
        tourEndTime,
        mealStartTime,
        mealEndTime,
        notificationComment,
        tourComment,
        myTourComment,
        tourContract,
        costCenter,
        wbse
      };
    }
    this.setState({
      itemDetails
    });
  }

  handleModalCancel = (e) => {
    this.setState({
      itemModal: false,
    });
  }

  handleTimeChange = (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) => {
    
    let startDateFixed = this.state.startDate;
    if (this.state && (this.state.startDate.length == 20 ||this.state.startDate.length == 25)) {
      startDateFixed = this.state.startDate.substring(0,10);
    }
    let minTime = dayjs(startDateFixed);
    let maxTime =0.0;
   
    if ( this.state == undefined) {
      console.log('visibleTime');
      
      updateScrollCanvas(visibleTimeStart, visibleTimeEnd);
      
    } else {
      if (this.state.scheduleFormat === 1 ) {
        maxTime = dayjs(startDateFixed).endOf('day');
      }
      else {
        maxTime = dayjs(startDateFixed).add(1, 'day').endOf('day');
      }
      
      if (visibleTimeStart < minTime && visibleTimeEnd > maxTime) {
        updateScrollCanvas(minTime, maxTime)
      } else if (visibleTimeStart < minTime) {
        updateScrollCanvas(minTime, minTime + (visibleTimeEnd - visibleTimeStart))
      } else if (visibleTimeEnd > maxTime) {
        updateScrollCanvas(maxTime - (visibleTimeEnd - visibleTimeStart), maxTime)
      } else {
        updateScrollCanvas(visibleTimeStart, visibleTimeEnd)
      }
    }
  }

  formatSubtitle = () => {
    dayjs.tz.setDefault("America/New_York");
    let startDate = dayjs(this.state.postedSchedule.startDate.substring(0,10)).format('MM/DD/YYYY') || null;
    let savedDate = dayjs(this.state.postedSchedule.savedDate.substring(0,19)).format('MM/DD/YYYY hh:mm a') || null;
    let userName = this.state.postedSchedule.userName || null;
    let resourceCollectionName = this.props.resourceCollectionInfo.name || null;
    dayjs.tz.setDefault("UTC");
  
    if(startDate && savedDate && userName && resourceCollectionName){
      return `Posting for ${resourceCollectionName} on ${startDate}. Posted on ${savedDate} by ${userName}`;
    }

    return '';
  }

  render() {

    if (this.state.backRedirect && !this.props.hamburgerMenu) {
      window.history.pushState(null, null, '#/schedules');
      this.props.navigate(this.state.backRedirect);
    }

    if (this.state.resources && this.state.tours && window.innerWidth) {
      dayjs.tz.setDefault('UTC');

      let startDateFixed = this.state.startDate.substring(0,10);

      return (
        <DashboardLayout>
          <PageTitle title={'Posted Schedule'}

            subTitle={this.formatSubtitle()} />
          <GanttChartTimeline
            groups={this.state.resources}
            items={this.state.tours}
            defaultTimeStart={dayjs(startDateFixed)}
            defaultTimeEnd={this.state.scheduleFormat === 2 ? dayjs(startDateFixed).add(1, 'day').add(2, 'hour') : dayjs(startDateFixed).add(1, 'day')}
            onTimeChange={this.handleTimeChange}
            minZoom={this.state.scheduleFormat === 2 ? (60 * 60 * 26 * 1000) : (60 * 60 * 24 * 1000)}
            maxZoom={this.state.scheduleFormat === 2 ? (60 * 60 * 26 * 1000) : (60 * 60 * 24 * 1000)}
            groupRenderer={groupRendererPosted}
            sidebarWidth={120}  // leftSidebar: defaults to 150
            resizeDetector={containerResizeDetector} // prevents blank rightSideBar
            itemRenderer={({ item, timelineContext, itemContext, getItemProps, getResizeProps }) => {
              const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();

              const itemProps = getItemProps({
                    onMouseDown: () => {
                      console.log("on item click", item);
                    },
                    onMouseUp: () => {
                      this.handleItemClick(item);
                    },
                    onTouchStart: () => { // Used to select item in chrome mobile.
                      this.handleItemClick(item);
                    }
                  });

              // Remove 'background' shorthand from library style to prevent it from
              // resetting backgroundColor. Only use backgroundColor (longhand).
              const { background: _bg, ...libStyle } = itemProps.style;

              const finalStyle = {
                ...libStyle,
                backgroundColor: item.backgroundColor,
                color: item.color || "white",
                borderColor: itemContext.selected ? "gold" : (item.borderColor || ""),
                borderStyle: item.borderStyle || "solid",
                borderWidth: itemContext.selected ? 2 : 2,
                borderRadius: 2,
                borderLeftWidth: itemContext.selected ? 3 : 1,
                borderRightWidth: itemContext.selected ? 3 : 1,
              };

              return (
                <div
                  {...itemProps}
                  style={finalStyle}
                >
                  {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}

                  <div
                    style={{
                      height: itemContext.dimensions.height,
                      overflow: "hidden",
                      paddingLeft: 3,
                      textOverflow: "string",
                      fontSize: 10,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {itemContext.title}
                  </div>

                  {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
                </div>
              );
            }}
            stackItems={true}
            itemHeightRatio={1}
            canMove={false}
            canResize={false}
            fixedHeader={false}
          >
            <TimelineHeaders
              style={{
                position: "sticky",
                top: 0,
                zIndex: 100
              }}
            >
              <SidebarHeader>
                {({ getRootProps }) => {
                  return <div {...getRootProps()}>
                    {/* width must match sidebarWidth */}
                    <h6 style={{ width: 120 }} className="rct-dateHeader-primary">Resource</h6></div>
                }}
              </SidebarHeader>

              < CustomPrimaryDateHeader
                unit="day"
                textAlign="center"
                widescreen={this.state.widescreen}
              />
              < CustomDateHeader
                unit="day"
                textAlign="center"
                widescreen={this.state.widescreen}
              />

              {this.state.widescreen &&
                (
                  <CustomHourlyHeader />
                )
              }

            </TimelineHeaders>
            <TimelineMarkers>
              <DayMarkers startDate={dayjs(this.state.startDate)} />
            </TimelineMarkers>
          </GanttChartTimeline>

          <Modal
            zIndex={2000}
            title={this.state.itemDetails.title}
            open={this.state.itemModal}
            onCancel={this.handleModalCancel} // the x in top right corner
            footer={[
              // <Button key="back" onClick={this.handleModalCancel}>Cancel</Button>,
              // <Button key="submit" type="submit" onClick={this.handleSearch}>
              //     Search
              // </Button>,
            ]}
          >
                <ItemModalDetails
                  itemDetails={this.state.itemDetails}
                  scheduleType={'postedSchedule'}
                  securityLevels={this.props.user.securityLevels}
                />

          </Modal>

        </DashboardLayout>
      )
    } else return <Spinner />
  }
}

PostedScheduleView.propTypes = {
  actions: PropTypes.object.isRequired,
  postedSchedule: PropTypes.object.isRequired,
  hamburgerMenu: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    postedSchedule: state.postedSchedules,
    resource: state.selectedResource,
    user: state.user,
    hamburgerMenu: state.navigation.hamburgerMenu,
    resourceCollectionInfo: state.resourceCollectionInformation,
    postedScheduleParameters: state.postedScheduleParameters,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchPostedSchedules: bindActionCreators(
        postedScheduleActions.fetchPostedSchedules,
        dispatch
      ),
      fetchResourceCollectionInformation: bindActionCreators(
        postedScheduleActions.fetchResourceCollectionInformation,
        dispatch
      ),
      updatedPostedScheduleParameters: bindActionCreators(
        postedScheduleActions.updatePostedScheduleParameters,
        dispatch
      ),
    }
  };
}

export const withRouter = (Component) => {
	const Wrapper = (props) => {
		const navigate = useNavigate();
    const location = useLocation();
		return <Component navigate={navigate}  {...props} location= {location} />;
	};
	return Wrapper;
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(PostedScheduleView));
